<template>
  <div
    :id="dom_id"
    class="googleMap"
  >
  </div>
</template>

<script setup>
import { renderAutoPause } from './utils/map-utils';

import { activityDetailStore } from '@client/store/activityDetailStore';
import { onMounted, reactive, computed, watch, ref, nextTick } from 'vue';
import { useMap } from './hooks/useMap';
import unitHelper from '@client/helper/unit';
import { darkMapPoint, lightMapPoint } from './SportMap/SportMap';
import { assetsRequire } from '@client/helper';
import { getGmapConstructor } from './utils/get-gmap';
import { initStore } from '@client/store/initStore';
import { userStore } from '@client/store/userStore';
import { activeTab } from '../../hooks/useActivityTabs';
import { newListData } from '../../main/table/hooks/useLapData';
const activityDetailStoreRef = activityDetailStore();

const initStoreRef = initStore();
const userStoreRef = userStore();
const THEME = initStoreRef.theme;

const { markLap, sportMap, stateMap, googleMapBounds, pakHo, snowStop, dom_id, initMarkLap, bindZoomChange } = useMap({
  setPakHoPoint,
  isGoogle: true
});
console.log('init google map');
let GmapClass;
getGmapConstructor(userStoreRef.currentLocale).then((cls) => {
  GmapClass = cls;
});

watch(sportMap, async () => {
  await initMarkLap();

  // state.$once('hook:beforeDestroy', () => {
  //   markLap.value = null;
  // });
  // 执行地图初始化;

  nextTick(async () => {
    await makeInit();
    setPakHoPoint(pakHo.value);
  });

  // console.log('map init finished');
});

const state = reactive({
  // Google高亮点数组
  heightBounds: [],
  // 底线数组
  underLines: [],
  // 全段Google坐标点
  fullPoint: [],
  // 全段总点
  allPoints: [],
  // 高亮圈路线数组
  selectedPath: [],
  // 圈标记数组
  circleArr: [],
  // 运动路径数组
  polyline: [],
  // 暂停区间数组
  stopLine: [],
  // 滑雪缆车区间数组
  snowLine: [],
  // 起点坐标
  markerStart: null,
  // 终点坐标
  markerEnd: null,
  // 周柏豪蓝色点图表联动点
  roadPoint: null,
  // 锁住肉汁
  isReload: false,
  // 芬尼丝
  isFinish: false
});

const activityDetail = computed(() => activityDetailStoreRef.activityDetail);
watch(activityDetail, () => {
  state.isReload = true;
  nextTick(() => {
    clearMap();
    makeInit();
  });
});

watch(activeTab, () => {
  nextTick(() => {
    initLapMarkers();
  });
});

// 清空地图
function clearMap() {
  for (let i = 0; i < state.selectedPath.length; i++) {
    state.selectedPath[i].setMap(null);
  }
  for (let i = 0; i < state.circleArr.length; i++) {
    state.circleArr[i].setMap(null);
  }
  for (let i = 0; i < state.polyline.length; i++) {
    state.polyline[i].setMap(null);
  }
  for (let i = 0; i < state.stopLine.length; i++) {
    state.stopLine[i].setMap(null);
  }
  for (let i = 0; i < state.snowLine.length; i++) {
    state.snowLine[i].setMap(null);
  }
  state.markerStart.setMap(null);
  state.markerEnd.setMap(null);
  googleMapBounds.value = [];
  state.heightBounds = [];
  state.fullPoint = [];
  state.allPoints = [];
  state.selectedPath = [];
  state.circleArr = [];
  state.polyline = [];
  state.stopLine = [];
  state.snowLine = [];
  state.markerStart = null;
  state.markerEnd = null;
  state.isFinish = false;
}
// init地图
async function makeInit() {
  if (!GmapClass) {
    GmapClass = await getGmapConstructor();
  }
  const { frequencyList, pauseList } = activityDetailStoreRef.activityDetail;

  //  描绘底线
  if (state.underLines.length === 0) await makeGooglePoint();
  //  描绘路径
  await makeShowLine();
  //  起点标记
  state.markerStart = await makeMarker(state.fullPoint[0], 's');
  await state.markerStart.setMap(stateMap.value);
  //  终点标记
  state.markerEnd = await makeMarker(state.fullPoint[state.fullPoint.length - 1], 'e');
  await state.markerEnd.setMap(stateMap.value);
  //  设置地图显示的中心点
  await stateMap.value.setCenter(googleMapBounds.value.getCenter());
  //  设置地图显示的缩放级别
  await stateMap.value.fitBounds(googleMapBounds.value);

  //  设置有缆车情况下的缆车路线
  if (snowStop.value.length > 0) await setSnowLine();

  //  设置有自动暂停情况下的自动暂停路线
  renderAutoPause({
    //
    map: stateMap.value,
    points: JSON.parse(JSON.stringify(frequencyList)),
    pauses: JSON.parse(JSON.stringify(pauseList)),
    theme: THEME,
    transformedGps: null,
    isGoogle: true
  });

  setTimeout(() => {
    initLapMarkers();
    sportMap.value.renderCheckPoints();
  }, 1000);

  // 地图加载完成
  state.isFinish = true;
}

// 描绘缆车路径
function setSnowLine() {
  state.snowLine = [];
  for (let i = 0; i < snowStop.value.length; i++) {
    const path = [];
    for (let j = 0; j < snowStop.value[i].length; j++) {
      const a = snowStop.value[i][j].gpsLon / 10000000;
      const b = snowStop.value[i][j].gpsLat / 10000000;
      if (!a || !b) continue;
      path.push({ lat: b, lng: a });
    }
    const line = new GmapClass.Polyline({
      path,
      strokeColor: THEME === 'theme-dark' ? '#5C9E3C' : '#96D407',
      strokeOpacity: 1.0,
      strokeWeight: 3,
      zIndex: 53
    });
    state.snowLine.push(line);
  }
  //  把线设置到地图上
  for (let i = 0; i < state.snowLine.length; i++) {
    state.snowLine[i].setMap(stateMap.value);
  }
}

const selectedData = computed(() => activityDetailStoreRef.selectedData);
watch(selectedData, () => {
  setTimeout(() => {
    if (state.isReload) return;
    setSelectData(selectedData.value);
  });
});

// 设置地图上的高亮线
function setSelectData(val) {
  // 清除已有高亮线
  if (state.selectedPath.length > 0) {
    for (let i = 0; i < state.selectedPath.length; i++) {
      state.selectedPath[i].setMap(null);
    }
    state.selectedPath = [];
    state.heightBounds = [];
  }
  // 有高亮圈的时候
  if (val.length > 0) {
    let _selectedPath = state.selectedPath;
    const selectItems = val.map((listRowIndex) => {
      return newListData.value.find((i) => i.listRowIndex === listRowIndex);
    });
    // 创建bounds对象用来调整自动缩放
    state.heightBounds = new GmapClass.LatLngBounds();
    // 筛选并生成高亮线
    for (let i = 0; i < val.length; i++) {
      const selectItem = selectItems[i];
      const s = selectItem.startTimestamp;
      const e = selectItem.endTimestamp;
      const line = [];
      let sock = 0;
      for (let j = sock; j < state.allPoints.length; j++) {
        const x = state.allPoints[j].timestamp;
        if (s <= x && x <= e) {
          const a = state.allPoints[j].gpsLon / 10000000;
          const b = state.allPoints[j].gpsLat / 10000000;
          line.push({ lat: b, lng: a });
          state.heightBounds.extend(new GmapClass.LatLng(b, a));
        }
        if (x > e) {
          sock = j - 1;
          break;
        }
      }
      const pl = makeHeightLine(line);
      _selectedPath.push(pl);
    }
    //  把路径修改成低亮颜色
    for (let i = 0; i < state.polyline.length; i++) {
      state.polyline[i].setOptions({
        strokeColor: THEME === 'theme-dark' ? '#A0B341' : '#E2EBB7'
      });
    }
    state.selectedPath = _selectedPath;
    console.log(`🔔 _selectedPath`, _selectedPath);
    //  把高亮线设置到地图上
    for (let i = 0; i < state.selectedPath.length; i++) {
      state.selectedPath[i].setMap(stateMap.value);
    }
    //  设置地图显示的中心点
    stateMap.value.setCenter(state.heightBounds.getCenter());
    //  设置地图显示的缩放级别
    stateMap.value.fitBounds(state.heightBounds);
  } else {
    // 无高亮圈的时候，重新恢复原来地图
    for (let i = 0; i < state.polyline.length; i++) {
      state.polyline[i].setOptions({
        strokeColor: THEME === 'theme-dark' ? '#DDFF00' : '#BDD707'
      });
    }
    //  设置地图显示的中心点
    stateMap.value.setCenter(googleMapBounds.value.getCenter());
    //  设置地图显示的缩放级别
    stateMap.value.fitBounds(googleMapBounds.value);
  }
}
// 生成高亮线
function makeHeightLine(path) {
  return new GmapClass.Polyline({
    path,
    strokeColor: THEME === 'theme-dark' ? '#DDFF00' : '#BDD707',
    strokeOpacity: 1.0,
    strokeWeight: 3,
    zIndex: 52
  });
}

function initLapMarkers() {
  // console.log(`🔔 initLapMarkers`);
  const { activityDetail } = activityDetailStoreRef;

  markLap.value
    .setSummary(activityDetail?.summary)
    .calcMaximum4markers(activityDetail?.frequencyList)
    .calcLaps2mark(activityDetail?.lapList, activityDetail?.frequencyList)
    .renderMarker4laps();

  bindZoomChange();
}
// 处理谷歌地图点并生成底线
function makeGooglePoint() {
  //  处理gps点
  if (activityDetailStoreRef.activityDetail?.handStop?.length > 0) {
    for (let i = 0; i < activityDetailStoreRef.activityDetail?.handStop.length; i++) {
      const path = [];
      for (let j = 0; j < activityDetailStoreRef.activityDetail?.handStop[i].length; j++) {
        const a = activityDetailStoreRef.activityDetail?.handStop[i][j].gpsLon / 10000000;
        const b = activityDetailStoreRef.activityDetail?.handStop[i][j].gpsLat / 10000000;
        if (!a || !b) continue;
        path.push({ lat: b, lng: a });
      }
      const line = new GmapClass.Polyline({
        path,
        strokeColor: THEME === 'theme-dark' ? '#A0B341' : '#E2EBB7',
        strokeOpacity: 1.0,
        strokeWeight: 3,
        zIndex: 50
      });
      state.underLines.push(line);
    }
  } else {
    const path = [];
    for (let i = 0; i < activityDetailStoreRef.activityDetail?.frequencyList.length; i++) {
      const a = activityDetailStoreRef.activityDetail?.frequencyList[i].gpsLon / 10000000;
      const b = activityDetailStoreRef.activityDetail?.frequencyList[i].gpsLat / 10000000;
      if (!a || !b) continue;
      path.push({ lat: b, lng: a });
    }
    const line = new GmapClass.Polyline({
      path,
      strokeColor: THEME === 'theme-dark' ? '#A0B341' : '#E2EBB7',
      strokeOpacity: 1.0,
      strokeWeight: 3,
      zIndex: 50
    });
    state.underLines.push(line);
  }
  //  把线设置到地图上
  for (let i = 0; i < state.underLines.length; i++) {
    state.underLines[i].setMap(stateMap.value);
  }
}
// 生成路径
function makeShowLine() {
  googleMapBounds.value = new GmapClass.LatLngBounds();
  state.isReload = false;
  // 判断是否有过滤数据
  if (activityDetailStoreRef.activityDetail?.handStop?.length > 0) {
    for (let i = 0; i < activityDetailStoreRef.activityDetail.handStop.length; i++) {
      const path = [];
      for (let j = 0; j < activityDetailStoreRef.activityDetail.handStop[i].length; j++) {
        const a = activityDetailStoreRef.activityDetail.handStop[i][j].gpsLon / 10000000;
        const b = activityDetailStoreRef.activityDetail.handStop[i][j].gpsLat / 10000000;
        if (!a || !b) continue;
        path.push({ lat: b, lng: a });
        state.fullPoint.push({ lat: b, lng: a });
        state.allPoints.push(activityDetailStoreRef.activityDetail.handStop[i][j]);
        googleMapBounds.value.extend(new GmapClass.LatLng(b, a));
      }
      const line = new GmapClass.Polyline({
        path,
        strokeColor: THEME === 'theme-dark' ? '#DDFF00' : '#BDD707',
        strokeOpacity: 1.0,
        strokeWeight: 3,
        zIndex: 51
      });
      state.polyline.push(line);
    }
  } else {
    const path = [];
    for (let i = 0; i < activityDetailStoreRef.activityDetail.frequencyList.length; i++) {
      const a = activityDetailStoreRef.activityDetail.frequencyList[i].gpsLon / 10000000;
      const b = activityDetailStoreRef.activityDetail.frequencyList[i].gpsLat / 10000000;
      if (!a || !b) continue;
      path.push({ lat: b, lng: a });
      state.fullPoint.push({ lat: b, lng: a });
      state.allPoints.push(activityDetailStoreRef.activityDetail.frequencyList[i]);
      googleMapBounds.value.extend(new GmapClass.LatLng(b, a));
    }
    const line = new GmapClass.Polyline({
      path,
      strokeColor: THEME === 'theme-dark' ? '#DDFF00' : '#BDD707',
      strokeOpacity: 1.0,
      strokeWeight: 3,
      zIndex: 51
    });
    state.polyline.push(line);
  }
  //  把线设置到地图上
  for (let i = 0; i < state.polyline.length; i++) {
    state.polyline[i].setMap(stateMap.value);
  }
}
// 生成起点终点标记
function makeMarker(path, type) {
  if (type === 's') {
    return new GmapClass.Marker({
      zIndex: 58,
      position: path,
      icon:
        THEME === 'theme-dark'
          ? assetsRequire('@assets/coros-v2/images/training-hub-v2/icons/dark-startMap.png')
          : assetsRequire('@assets/coros-v2/images/training-hub-v2/icons/light-startMap.png')
    });
  } else {
    return new GmapClass.Marker({
      zIndex: 58,
      position: path,
      icon:
        THEME === 'theme-dark'
          ? assetsRequire('@assets/coros-v2/images/training-hub-v2/icons/dark-endMap.png')
          : assetsRequire('@assets/coros-v2/images/training-hub-v2/icons/light-endMap.png')
    });
  }
}

// 设置鼠标当前在图表上对应的点
function setPakHoPoint(val) {
  if (!val || !val.data || unitHelper.isNoValue(val.data.gpsLon) || unitHelper.isNoValue(val.data.gpsLat)) {
    console.log('kong');
    return;
  }

  if (!state.isFinish) return;
  const a = val.data.gpsLon / 10000000;
  const b = val.data.gpsLat / 10000000;
  const path = { lat: b, lng: a };

  if (state.roadPoint) {
    state.roadPoint.setPosition(path);
    return;
  }

  state.roadPoint = new GmapClass.Marker({
    zIndex: 60,
    position: path,
    anchorPoint: new GmapClass.Point(-12, -12),
    icon: {
      url: THEME === 'theme-dark' ? darkMapPoint : lightMapPoint,
      anchor: new GmapClass.Point(12, 12)
    }
  });
  state.roadPoint.setMap(stateMap.value);
}
</script>

<style scoped lang="scss">
.googleMap {
  width: 100%;
  height: 100%;

  :deep(.gmnoprint),
  :deep(.gm-style-cc) {
    display: none;
  }
}
</style>
